import React, {useMemo} from "react";

import {Checkbox, CheckboxProps, Col} from "antd";
import {CheckboxGroupProps} from "antd/es/checkbox";
import {useDataAll} from "../../../api/useDataAll";
import {queries} from "../../../api/queries";
import {SellerBatchType} from "../../../api/apiTypes";
import {useTranslation} from "react-i18next";
import Lottie from "lottie-react";
import '../../screens/shipping/shippingScreen.css';
import spinner from "../../../assets/lotties/spinner.json";
import {removeExistingParamsArrayValue} from "../../../common/fns";
import {useSearchParams} from "react-router-dom";

interface Props extends CheckboxGroupProps {
}

const SellerBatchFilter = ({value}: Props) => {
  const {t} = useTranslation(["shipping"]);
  const [_, setSearchParams] = useSearchParams();
  const {listData, isLoading} = useDataAll<SellerBatchType>(queries.batches, {ordering: '-round'});
  const checkAll = value && listData?.length > 0 && listData?.length === value.length;
  
  console.log("SellerBatchFilter = ", listData);
  const allUuid = useMemo(() => {
    if (listData) {
      return listData.map((batch) => batch.uuid);
    }
    return [];
  }, [listData]);
  
  const handleChangeChecked = (checkedValues: any[]) => {
    console.log("checked = ", checkedValues);
    setSearchParams((prev) => ({
      ...removeExistingParamsArrayValue(prev, "pickup_batch__uuid__in", checkedValues),
      pickup_batch__uuid__in: checkedValues
    }));
  };
  
  const handleCheckAll: CheckboxProps['onChange'] = (e) => {
    console.log("handleCheckAll = ", e, allUuid);
    if (e.target.checked) {
      setSearchParams((prev) => ({
        ...removeExistingParamsArrayValue(prev, "pickup_batch__uuid__in", allUuid), pickup_batch__uuid__in: allUuid
      }));
    }
    else {
      setSearchParams((prev) => ({
        ...removeExistingParamsArrayValue(prev, "pickup_batch__uuid__in", value), pickup_batch__uuid__in: [],
      }));
    }
  };
  
  return (<div className={"column"}>
    <div className={"title"}>
      <span>{t("batch")}</span>
      <Checkbox className={"checkAll"} onChange={handleCheckAll}
                checked={checkAll}>
        전체
      </Checkbox>
    </div>
    <Checkbox.Group
      className={"wrapper-rd-wh-sm check"}
      value={value}
      onChange={handleChangeChecked}
    >
      <Col>
        {listData && listData.length ? listData.map((s, idx) => (<Checkbox
          key={"check" + idx}
          rootClassName={"item"}
          data-cy="homeManageCheckbox"
          value={s.uuid}
        >
          {`${s.seller_name} ${s.round}(${s.return_count + s.shipping_count})`}
        </Checkbox>)) : (isLoading ? <Lottie autoplay animationData={spinner} loop style={{height: 25}} /> : <span
          className={"nodata"}>데이터가 없습니다</span>)}
      </Col>
    </Checkbox.Group>
  </div>);
};

export default SellerBatchFilter;
